import { graphql } from 'react-relay';

export const saveRefundActionLog = graphql`
  mutation saveRefundActionLogMutation($refundId: String, $actionCode: String, $actionStatus: String!) {
    saveRefundActionLog(refundId: $refundId, actionCode: $actionCode, actionStatus: $actionStatus) {
      result
      errors {
        code
      }
    }
  }
`;
